import React from 'react'
import styles from "styles/pages/Pages.module.scss";
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { RenderUnit } from './RenderUnit';

export const RenderDivision = (division, rowPosition, getChildren, hanndleSelectId, expanded, id, toggleExpand) => {
        const units = getChildren(division.id, "unit");
        const isExpanded = expanded[division.id];
        const hasChildren = units.length > 0;

        return (
            <React.Fragment key={division.id}>
                <div 
                    className={`${styles.containerDivInfo} ${division.id === id && styles.select}`}
                    style={{ gridColumn: '2', gridRow: rowPosition }}
                    onClick={() => hanndleSelectId(division.id)}
                >
                    <div className={styles.divText}>
                        {hasChildren && (
                            <div onClick={(e) => toggleExpand(division.id, e)}>
                                {isExpanded ? 
                                    <ChevronRightRoundedIcon size={20} /> : 
                                    <ChevronLeftRoundedIcon size={20} />
                                }
                            </div>
                        )}
                        <span className={styles.divName}>{division.name}</span>
                    </div>
                </div>
                {isExpanded && units.map((unit, idx) => RenderUnit(unit, rowPosition + idx, hanndleSelectId, id))}
            </React.Fragment>
        );
    };
